import validator from "validator";

var errorMessage = "valid";

export const validateForm = (label, value, validations, placeholder, type) => {
  errorMessage = "valid";
  validations &&
    value !== undefined &&
    validations.map(data => {
      switch (data) {
        case "onlyAlpha":
          if (errorMessage === "valid") {
            onlyAlpha(label, value);
          }
          break;
        case "positiveNumber":
          if (errorMessage === "valid") {
            positiveNumber(label, value);
          }
          break;
        case "onlyNumber":
          if (errorMessage === "valid") {
            onlyNumber(label, value);
          }
          break;
        case "codeSize":
          if (errorMessage === "valid") {
            codeSize(label, value);
          }
          break;
        case "maxSize":
          if (errorMessage === "valid") {
            maxSize(label, value);
          }
          break;
        case "aboveMaxSize":
          if (errorMessage === "valid") {
            aboveMaxSize(label, value);
          }
          break;
        case "minSize":
          if (errorMessage === "valid") {
            minSize(label, value);
          }
          break;
        case "password":
          if (errorMessage === "valid") {
            password(label, value);
          }
          break;
        case "email":
          if (errorMessage === "valid") {
            email(label, value);
          }
          break;
        case "required":
          if (errorMessage === "valid") {
            required(label, value, placeholder, type);
          }
          break;
        case "percentageCheck":
          if (errorMessage === "valid") {
            percentageCheck(label, value);
          }
          break;
        default:
      }
      return true;
    });
  return errorMessage;
};

const required = (label, value, placeholder, type) => {
  if (label === undefined) label = "This field";
  switch (type) {
    case "number":
      if (value === null || isNaN(value) || value == "") {
        errorMessage = `${label} is required`;
      }
      break;
    default:
      if (value === null || !value.toString().trim().length) {
        errorMessage = `${label} is required`;
      }
      break;
  }
};

const email = (label, value) => {
  if (value === null || !value.toString().trim().length) {
    errorMessage = `Email is required.`;
  } else if (!validator.isEmail(value)) {
    errorMessage = `${value} is not a valid email.`;
  } else {
    errorMessage = "valid";
  }
};

export const password = (label, value) => {
  const minLength = 6;
  const passLength = value !== null && value.toString().trim().length;
  if (!passLength) {
    errorMessage = `Password is required`;
  } else if (passLength < minLength) {
    errorMessage = `Minimum 6 characters required`;
  }
  // else if (!(/(?=.*\d)(?=.*[!@#$%^&amp;*()_+}{&quot;:;'?&gt;.&lt;,])(?!.*\s).*$/ig.test(value))) {
  //   errorMessage = 'Must be a combination of alphabets, numeric and special characters'
  // }
  else {
    errorMessage = "valid";
  }
};

const codeSize = (label, value) => {
  const maxLength = 20;
  const textLength = value !== null && value.toString().trim().length;
  if (textLength > maxLength) {
    errorMessage = `Maximum ${maxLength} characters allowed`;
  } else {
    errorMessage = "valid";
  }
};

const maxSize = (label, value) => {
  const maxLength = 50;
  const textLength = value !== null && value.toString().trim().length;
  if (textLength > maxLength) {
    errorMessage = `Maximum ${maxLength} characters allowed`;
  } else {
    errorMessage = "valid";
  }
};
const aboveMaxSize = (label, value) => {
  const maxLength = 255;
  const textLength = value !== null && value.toString().trim().length;
  if (textLength > maxLength) {
    errorMessage = `Maximum ${maxLength} characters allowed`;
  } else {
    errorMessage = "valid";
  }
};

const minSize = (label, value) => {
  const minLength = 3;
  const textLength = value !== null && value.toString().trim().length;
  if (!textLength || textLength < minLength) {
    errorMessage = `Minimum ${minLength} characters required`;
  } else {
    errorMessage = "valid";
  }
};

const onlyAlpha = (label, value) => {
  let length = value !== null && value.toString().trim().length;
  if (length > 0 && !/^[a-zA-Z ]+$/gi.test(value)) {
    return (errorMessage = "Only aplphabets are allowed");
  } else {
    errorMessage = "valid";
  }
};

const onlyNumber = (label, value) => {
  let length = value !== null && value.toString().trim().length;
  if (length > 0 && !/[0-9]/gi.test(value)) {
    return (errorMessage = "Only Numbers are allowed");
  } else {
    errorMessage = "valid";
  }
};

const positiveNumber = (label, value) => {
  let length = value !== null && value.toString().trim().length;
  if (length > 0 && !/^[+]?([0-9]+(?:[\.][0-9]*)?|\.[0-9]+)$/gi.test(value)) {
    return (errorMessage = "Only positive numbers are allowed");
  } else if (length > 0 && value === "0") {
    return (errorMessage = "Should be greater than 0");
  } else {
    errorMessage = "valid";
  }
};

const percentageCheck = (label, value) => {
  let length = value !== null && value.toString().trim().length;
  value = parseFloat(value);
  if (length > 0 && value > 100) {
    return (errorMessage = "Percentage should not exceed 100");
  } else {
    errorMessage = "valid";
  }
};

export const validForm = (formErrors, formData = {}) => {
  const isFieldblank = checkAllFields(formData);
  const keys = Object.keys(formErrors).filter(
    value => formErrors[value].length > 0 && formErrors[value] !== "valid"
  );
  if (isFieldblank || keys.length > 0) {
    return true;
  } else {
    return false;
  }
};

const checkAllFields = formData => {
  const blanks = Object.keys(formData).filter(
    key => formData[key] === "" || formData[key] === null
  );
  return blanks.length !== 0;
};



// WEBPACK FOOTER //
// ./src/components/FormElement/FormValidator.js